import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../services/util/withRouter';
import { Card, TabPane, Col } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import qs from 'qs';
import PageTiltleCard from '../Dashboard/CardHandling/PageTitleCard/PageTitleCard';

import firestore from '../../services/api/firestore';
import {
	collection,
	query,
	QuerySnapshot,
	onSnapshot,
	where
} from 'firebase/firestore';

import machineApi from '../../services/api/machines';
import walletApi from '../../services/api/wallet';
import messagesApi from '../../services/api/messages';
import systemApi from '../../services/api/system';
import customerApi from '../../services/api/customers';

import Modal from 'react-bootstrap/Modal';

import DashboardCardContainerWithFlow from '../Dashboard/CardHandling/DashboardCardContainerWithFlow';
import DeviceDetailsTabs from '../../components/Tabs';
import CustomerList from './CustomerList/CustomerList';
import FilterBar from '../FilterBar/FilterBar';
import store from '../../store/index';
import { setLoadedCustomer } from '../../store/invisibleTouch';
import respUtil from '../../services/util/responsibilityUtil';
import TransactionList from './TransactionList/TransactionList';
import InvoiceList from './InvoiceList/InvoiceList';

class InvisibleTouchManager extends Component {
	state = {
		currency: [],
		partnerWallet: [],
		purchasers: [],
		filteredPurchasers: [],
		panel: null,
		openIdx: null,
		transactions: [],
		machines: [],
		messages: [],
		filtered: true,
		activePageKey: 0,
		currentFilterValue: '',
		filteredCustomers: [],
		unreadMessagesUsers: []
	};
	subscriptions = [];

	componentDidMount = () => {
		const unreadMessages = this.getURLUnreadMessages();
		this.state.filterUnreadMessages = !!unreadMessages; // We dont want state update

		this.loadPartnerWalletData(this.props.user.cmID);
		this.loadMachines(() => this.loadPurchasers());
	};

	componentWillUnmount() {
		this.subscriptions.forEach(unSub => unSub());
	}

	loadMachines = promise => {
		machineApi.getVisibleVendingMachines().then(mg => {
			let machines = mg ? mg.data.response : [];
			this.setState(
				{
					machines: machines
				},
				() => promise()
			);
		});
	};

	loadPartnerWalletData = cmID => {
		if (cmID) {
			var currencyResponse = null;
			var partnerResponse = null;
			var partnerWalletResponse = null;

			Promise.all([
				new Promise(async (resolve, reject) => {
					currencyResponse = await systemApi.getCurrencies();
					resolve();
				}),
				new Promise(async (resolve, reject) => {
					partnerResponse = await customerApi.getCustomer(this.props.user.cmID);
					resolve();
				}),
				new Promise(async (resolve, reject) => {
					partnerWalletResponse = await walletApi.getPartnerWallet(cmID);
					resolve();
				})
			]).then(() => {
				let currency = null;
				if (
					partnerWalletResponse &&
					partnerWalletResponse.data &&
					partnerWalletResponse.data.wallets &&
					partnerWalletResponse.data.wallets.length > 0
				) {
					if (
						partnerWalletResponse.data.wallets[0].currencyID &&
						currencyResponse &&
						currencyResponse.data &&
						currencyResponse.data.currencies &&
						currencyResponse.data.currencies.length > 0
					) {
						currency = currencyResponse.data.currencies.filter(
							e => e.id === partnerWalletResponse.data.wallets[0].currencyID
						);
					}

					this.loadUnreadMessages(partnerWalletResponse.data.wallets[0].id);
				}
				this.setState({
					partner: partnerResponse.data.response[0],
					partnerWallet: partnerWalletResponse.data.wallets,
					currency: currency
				});
			});
		}
	};

	loadUnreadMessages(walletID) {
		firestore.get().then(db => {
			const q = query(
				collection(db, 'messages'),
				where('recipentIdentifier', '==', walletID),
				where('readDate', '==', null)
			);
			this.subscriptions.push(
				onSnapshot(q, data => this.onMessagesChange(data))
			);
		});
	}

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			this.onRouteChanged();
		}
	}

	onRouteChanged() {
		const userEmail = this.getURLUserParam();
		const unreadMessages = this.getURLUnreadMessages();

		if (userEmail) {
			const user = this.state.purchasers.find(
				user =>
					user &&
					user.email &&
					user.email.toLocaleUpperCase() == userEmail.toLocaleUpperCase()
			);
			if (user) {
				this.loadingPurchaserhandler(user, 4);
			}
		}
		if (unreadMessages) {
			this.setState({ unreadMessagesUsers: true });
		}
	}

	getURLUserParam = () =>
		qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).userEmail;

	getURLUnreadMessages = () =>
		qs.parse(this.props.location.search, { ignoreQueryPrefix: true })
			.unreadMessages;

	loadPurchasers = () => {
		walletApi.getPartnerWallet(this.props.user.cmID).then(res => {
			if (
				res &&
				res.data &&
				res.data.wallets &&
				res.data.wallets.length > 0 &&
				res.data.wallets[0].id
			) {
				walletApi.getPurchasers(res.data.wallets[0].id).then(res => {
					if (res && res.data && res.data.users && res.data.users.length > 0) {
						this.setState(
							{
								purchasers: res.data.users,
								filteredPurchasers: res.data.users.filter(e => e.email != null)
							},
							() => {
								const userEmail = this.getURLUserParam();
								if (!userEmail) {
									this.filterCustomers();
								} else {
									const user = this.state.purchasers.find(
										user =>
											user &&
											user.email &&
											user.email.toLocaleUpperCase() ==
												userEmail.toLocaleUpperCase()
									);
									if (user) {
										this.loadingPurchaserhandler(user, 4);
									} else {
										this.filterCustomers();
									}
								}
							}
						);
					}
				});
			}
		});
	};

	loadingPurchaserhandler = (row, pageIndex = 0) => {
		const currency = this.state.currency;
		let param = { ...row, currency };
		store.dispatch(setLoadedCustomer(param));
		this.props.history.push(
			`/invisible_touch_manager/customerDetailer?page=${pageIndex}`
		);
	};

	linkToPage = (page, row) => {
		const currency = this.state.currency;
		let param = { ...row, currency };
		store.dispatch(setLoadedCustomer(param));
		this.props.history.push(
			`/invisible_touch_manager/customerDetailer?page=${page}`
		);
	};

	onMessagesChange(data) {
		const loadedData = data.docs.map(doc => doc.data());
		const uniqueSenders = loadedData
			.map(message => message.senderIdentifier)
			.filter((item, i, ar) => ar.indexOf(item) === i);
		const uniqueSendersPlusCount = [];
		uniqueSenders.forEach(sender => {
			uniqueSendersPlusCount.push({
				email: sender,
				messageCount: loadedData
					.map(message => message.senderIdentifier)
					.filter(messageSender => messageSender == sender).length
			});
		});

		this.setState(
			{
				unreadMessagesUsers: uniqueSendersPlusCount
			},
			() => (this.state.filterUnreadMessages ? this.filterCustomers() : null)
		);
	}

	handleActivePageChange(newPageKey) {
		this.setState({ activePageKey: newPageKey }, () => {
			const newURL = `#/invisible_touch_manager?page=${newPageKey}`;
			// We only want to replace the current url without any navigation event,
			// since we have already loaded every neccesary data
			window.history.pushState({}, null, newURL);
		});
	}

	addCredithandler = (body, row) => {
		walletApi
			.addCreditToAnAccount(body)
			.then(res => this.loadingPurchaserhandler(row), this.showAlertModal());
	};

	showAlertModal = () => {
		this.setState({
			showAlertModal: true
		});
	};

	hideAlertModal = () => {
		this.setState({
			showAlertModal: false
		});
	};

	renderAlertModal = () => {
		return (
			<Modal
				show={this.state.showAlertModal}
				onHide={() => this.hideAlertModal()}
				centered
			>
				<Modal.Header
					closeButton
					style={{
						backgroundColor: 'var(--balance-mid)',
						color: 'var(--balance)'
					}}
				>
					<Modal.Title>
						{this.props.t('invisibleTouchManager.blancePanel.creditAlert')}
					</Modal.Title>
				</Modal.Header>
			</Modal>
		);
	};

	sendMessagehandler = (body, row) => {
		messagesApi
			.sendEmailMessage(body)
			.then(res => this.loadingPurchaserhandler(row))
			.catch(error => console.log(error));
	};

	editBillingStateHandler = (bsID, row, walletID) => {
		let body = {
			transactionID: row.id,
			billingStateID: bsID
		};

		walletApi
			.editBillingState(body)
			.then(res => this.loadingPurchaserhandler(walletID));
	};

	filterCustomers() {
		let customers = this.state.filtered
			? [...this.state.filteredPurchasers]
			: [...this.state.purchasers];
		let filteredCustomers = customers;
		let filterValue = this.state.currentFilterValue
			? this.state.currentFilterValue.trim().toUpperCase()
			: '';
		if (filterValue.length > 0) {
			filteredCustomers = customers.filter(customer => {
				let curCustomers = { ...customer };
				let promotionFieldArray = Object.values(curCustomers);
				return promotionFieldArray.some(
					val =>
						String(val)
							.toUpperCase()
							.indexOf(filterValue) >= 0
				);
			});
		}

		if (this.state.filterUnreadMessages) {
			filteredCustomers = this.state.unreadMessagesUsers
				.map(user =>
					filteredCustomers.find(customer => customer.email == user.email)
				)
				.filter(user => user); //remove undefined elements
		}

		this.setState({ filteredCustomers: filteredCustomers });
	}

	renderFilterBar = () => {
		return (
			<FilterBar
				filtered={this.state.filtered}
				key="filterbar"
				showFilterDeletedCustomersButton
				showUnreadMessagesCustomers
				isFiltered={filtered =>
					this.setState({ filtered: filtered }, () => this.filterCustomers())
				}
				filterUnreadMessages={this.state.filterUnreadMessages}
				onFilterChanged={value => this.onFilterChange(value)}
				onFilterUnreadMessages={newValue =>
					this.setState({ filterUnreadMessages: newValue }, () =>
						this.filterCustomers()
					)
				}
			/>
		);
	};
	onFilterChange(filteValue) {
		this.setState({ currentFilterValue: filteValue }, () =>
			this.filterCustomers()
		);
	}

	render() {
		const { t } = this.props;
		return (
			<div className="animated fadeIn">
				<DashboardCardContainerWithFlow>
					<Card body>
						<PageTiltleCard
							title={this.props.t('invisibleTouchManager.title')}
						/>
						<Col sm="12">
							<DeviceDetailsTabs
								onChangeActivePage={newPageKey =>
									this.handleActivePageChange(newPageKey)
								}
								activetab={this.state.activePageKey}
							>
								<TabPane
									title={t('invisibleTouchManager.purchasersTable.title')}
								>
									<CustomerList
										data={this.state.filteredCustomers}
										openIdx={this.state.openIdx}
										renderFilterBar={this.renderFilterBar}
										hideFilter={respUtil.breakpoints.sm}
										partner={this.state.partner}
										unreadMessagesUsers={this.state.unreadMessagesUsers}
										onLoadPurchaser={this.loadingPurchaserhandler}
										onFilterDeleted={this.filterDeletedPurchasers}
										onFilterChange={this.onFilterChange}
										onLink={this.linkToPage}
									/>
								</TabPane>
								<TabPane
									title={t('invisibleTouchManager.transactionTable.title')}
								>
									<TransactionList
										partnerWallet={this.state.partnerWallet}
										currency={this.state.currency}
										data={this.state.filteredCustomers}
									/>
								</TabPane>
								<TabPane title={t('invisibleTouchManager.invoicesTable.title')}>
									<InvoiceList
										partnerWallet={this.state.partnerWallet}
										currency={this.state.currency}
										data={this.state.filteredCustomers}
									/>
								</TabPane>
							</DeviceDetailsTabs>
						</Col>
					</Card>
				</DashboardCardContainerWithFlow>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	user: state.user,
	IVTState: state.invisibleTouch
});

export default connect(mapStateToProps)(
	withRouter(withTranslation()(InvisibleTouchManager))
);
